



























































import moment from 'moment';
import { Component, Vue, Watch, Prop, VModel } from 'vue-property-decorator';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/cs';

export interface DateRangeValue {
    type: 'period' | 'range';
    fromDate: string | null;
    toDate: string | null;
}

@Component({
    components: {
        DatePicker
    }
})
export default class DateRangePicker extends Vue {
    
    menu = false;
    text = "";
    currentMonth = 0;
    currentYear = 0;
    tab: number | null = null;
    dates: Array<Date> = [];
    
    @VModel() innerValue!: DateRangeValue;
    @Prop() label!: string | undefined;
    @Prop() placeholder!: string | undefined;
    
    mounted() {
        if (!this.innerValue) {
            this.tab = 0;
            this.$emit("input", {
                type: "period",
                fromDate: moment().format("YYYY-MM-01"),
                toDate: moment().endOf('month').format("YYYY-MM-DD")
            } as DateRangeValue);
        } else {
            if (this.innerValue.type === 'range') {
                this.tab = 1;
                this.text = moment(this.innerValue.fromDate).isValid() && moment(this.innerValue.toDate).isValid() ? moment(this.innerValue.fromDate).format("DD.MM.YYYY")+" - "+moment(this.innerValue.toDate).format("DD.MM.YYYY") : "";
                this.dates = [
                    moment(this.innerValue.fromDate).toDate(),
                    moment(this.innerValue.toDate).toDate()
                ];
            }
            else {
                this.text = moment(this.innerValue.fromDate).isValid() ? moment(this.innerValue.fromDate).format("MMMM YYYY") : "";
                this.currentMonth = Number(moment(this.innerValue.fromDate).format("MM"));
                this.currentYear = Number(moment(this.innerValue.fromDate).format("YYYY"));
            }
        }
    }
    
    @Watch("innerValue")
    innerValueChanged(v: DateRangeValue) {
        if (this.innerValue.type === 'range') {
            this.text = moment(this.innerValue.fromDate).format("DD.MM.YYYY")+" - "+moment(this.innerValue.toDate).format("DD.MM.YYYY");
        }
        else {
            this.text = moment(this.innerValue.fromDate).isValid() ? moment(this.innerValue.fromDate).format("MMMM YYYY") : "";
            this.currentMonth = Number(moment(this.innerValue.fromDate).format("MM"));
            this.currentYear = Number(moment(this.innerValue.fromDate).format("YYYY"));
        }
    }

    @Watch("dates")
    datesChanged(v: Array<string>) {
        if (v.length === 2 && moment(v[0]).isValid() && moment(v[1]).isValid()) {
            this.text = moment(v[0]).format("DD.MM.YYYY")+" - "+moment(v[1]).format("DD.MM.YYYY");
            this.$emit("input", {
                type: "range",
                fromDate: moment(v[0]).format('YYYY-MM-DDTHH:mm:ss'),
                toDate: moment(v[1]).format('YYYY-MM-DDTHH:mm:ss')
            } as DateRangeValue);
        }
        
    }
    
    get years(): number[] {
        const items = [];
        for (let year = 2020; year <= new Date().getFullYear(); year++) {
            items.push(year);
        }
        return items;
    }
    
    private getMonthName(monthNumber: number) {
        return moment(new Date(2000, monthNumber - 1, 1)).format('MMMM');
    }
    
    private monthClick(monthNumber: number) {
        let year = Number(moment().format("YYYY"));
        if (this.innerValue.type === "period") {
            year = Number(moment(this.innerValue.fromDate).format("YYYY"));
        }
        this.$emit("input", {
            type: "period",
            fromDate: moment(new Date(year, monthNumber - 1, 1)).format("YYYY-MM-01"),
            toDate: moment(new Date(year, monthNumber - 1, 1)).endOf('month').format("YYYY-MM-DD")
        } as DateRangeValue);
    }
    
    private yearClick(yearNumber: number) {
        const month = Number(moment(this.innerValue.fromDate).format("MM"));
        this.$emit("input", {
            type: "period",
            fromDate: moment(new Date(yearNumber, month - 1, 1)).format("YYYY-MM-01"),
            toDate: moment(new Date(yearNumber, month - 1, 1)).endOf('month').format("YYYY-MM-DD")
        } as DateRangeValue);
    }
    
}
